import { ApolloProvider, gql } from '@apollo/client'
import { FarolProvider } from '@farol-ds/react'

import { BoxLockWithProvider } from './box-lock-with-provider'
import { ModalProvider } from './components'
import { ModalSuccess } from './components/modal-success'
import { BoxModalProps } from './types'

export function BoxModal(props: BoxModalProps) {
  if (!props.viewer) {
    return null
  }
  return (
    <FarolProvider>
      <ApolloProvider client={props.client}>
        <ModalProvider resolveEmbeddedCheckout={props.resolveEmbeddedCheckout}>
          <BoxLockWithProvider {...props} />
          <ModalSuccess />
        </ModalProvider>
      </ApolloProvider>
    </FarolProvider>
  )
}

BoxModal.fragments = {
  viewer: gql`
    fragment BoxModal_viewer on Profile {
      pid
    }
  `,
}
